import type { ExecutionStatus } from '@mct/shared';

export const SIGNAL_COLOR: Record<ExecutionStatus, string> = {
  not_started: 'rgb(156 163 175)', // tailwind signal.idle
  in_progress: 'rgb(234 179 8)', // signal.progress
  blocked: 'rgb(239 68 68)', // signal.blocked
  done: 'rgb(34 197 94)', // signal.done
  skipped: 'rgb(203 213 225)', // slate-300
};

export const SIGNAL_LABEL: Record<ExecutionStatus, string> = {
  not_started: '未着手',
  in_progress: '進行中',
  blocked: 'ブロック',
  done: '完了',
  skipped: 'スキップ',
};

export const STATUS_OPTIONS: ExecutionStatus[] = [
  'not_started',
  'in_progress',
  'blocked',
  'done',
  'skipped',
];
